import React from 'react';
import Dexie from 'dexie';
import DateHelper from "../helpers/date-helper";
import { PAST_DAYS, FUTURE_DAYS, ServerUri } from "../settings";
import notification from "../helpers/toast_notification";
import moment from 'moment';
import {
  PDFDocumentFactory,
  PDFDocumentWriter,
  drawImage,
  drawLinesOfText
} from "pdf-lib";
import { fetchCoordinates } from '../helpers/utils';
import { Text } from '../extensions/LangaugeContainer';
export default class DbTasks {
  constructor() {
    this.db = new Dexie("lieferAppointments");

    this.db.version(1).stores({ auftrags: 'id, UniqueID, Datum', positions: 'id, AuftragId, UniqueID', persons: 'id, idFirma', pictures: '++id', geoLocations: 'id', files: 'id', bocks: 'id', entereddata: '++id, UniqueID' })
    this.db.version(2).stores({ auftrags: 'id, UniqueID, Datum', positions: 'id, AuftragId, UniqueID', persons: 'id, idFirma', pictures: '++id', geoLocations: 'id', files: 'id', bocks: 'id', entereddata: '++id, UniqueID', drivers: 'id' })
  }

  doSync = async (settings, reportStatus) => {
    if (reportStatus) reportStatus(0, "Sending data");
    let uploadStatus = await this.uploadAllDataToService(settings);

    if (uploadStatus.Error) {
      notification(
        "error",
        <Text tid="syncFailMessage"/>
        // "Synchronisation nicht erfolgreich! Bitte versuchen Sie zu einem späterem Zeitpunkt!"
      );
      reportStatus(100, "Failed");
      return;
    }


    let serviceDataP = this.getAllDataFromService(settings);
    let dbAppointmentsP = this.getAllAppointments();
    let dbBocksP = this.getAllBocks();
    let dbPersonsP = this.getAllPersons();
    let dbPositionsP = this.getAllPositions();
    let serviceDataFilesP = this.getAllFilesFromService(settings);
    let dbFilesP = this.getAllAttachments(); //PDF files

    let ed = await this.getAllEnteredData();
    ed = ed.filter(c => c.Geliefert === 1 || c.Geliefert === 2);
    await this.db.table("entereddata").bulkDelete(ed.map(row => row.id));

    let res = [
      await serviceDataP,
      await dbAppointmentsP,
      await dbBocksP,
      await dbPersonsP,
      await dbPositionsP,
      await serviceDataFilesP,
      await dbFilesP
    ];

    let serviceData = res[0];
    let appointments = serviceData.Values;
    let dbAppointments = res[1];
    let dbBocks = res[2];
    let bocks = serviceData.BockList;
    let dbPersons = res[3];
    let persons = serviceData.KundenList;
    let dbPositions = res[4];
    let positions = serviceData.Positions;
    let files =res[5]==null?[]:res[5].attachments;
    let dbFiles = res[6];


    await this.updateDBAppointments(dbAppointments, appointments);

    await this.updateDBBocks(dbBocks, bocks);

    await this.updateDBPersons(dbPersons, persons);

    await this.updateDBPositions(dbPositions, positions);

    await this.updateDBAttachments(dbFiles, files);

    if (reportStatus) {
      reportStatus(100, "Done");
      //notification("success", "Synchronisation war erfolgreich!");
    }
  }

  uploadAllDataToService = async settings => {
    let ed = await this.getAllEnteredData();
    // let monteureResponse;
    ed = ed.filter(e => e.Geliefert === 1 || e.Geliefert === 2);

    //console.log("Auftrags: ", ed);

    let data = ed.map(row => {
      return {
        AuftragNr: row.AuftragNr,
        Geliefert: row.Geliefert,
        GeliefertDescription: row.GeliefertDescription === null ? "" : row.GeliefertDescription.slice(0,149), //u servisu GeliefertDescription je max 150 char.
        UniqueID: row.UniqueID,
        Device: settings.CurrentUserName,
        Type: row.GeliefertDescription === "Bock rückgabe" ? 2 : 1,
        Monteri: row.Persons || [],
        SignedFiles: row.Pdf,
        PdfName: row.PdfName,
        KundenBesonderheiten: row.KundenBesonderheiten,
        IdFirma: row.IdFirma,
        Punkt1: row.Punkt1 || false,
        Punkt2: row.Punkt2 || false,
        Punkt3: row.Punkt3 || false
      }
    });

    let monteri = data.map(row => {
      if (row.Monteri.length > 0) {
        return row.Monteri;
      }else return {};
    });
    //Filtriraj sve prazne objekte iz montera.
    monteri = monteri.filter(e => e.Name);
    let fotosFromDb = await this.getAllFotos();
    //console.log(fotosFromDb);
    let fotosForUpload = [];
    ed.forEach(row => {
      let filtered = fotosFromDb.filter(i => i.UniqueID === row.UniqueID);
      if (filtered) {
        return filtered.forEach((val, index) => {
          fotosForUpload.push({
            ImageB64: val.data,
            AuftragNr: val.AuftragNr,
            UniqueID: val.UniqueID,
            PictureIndexForAuftrag: index + 1,
            id: val.id
          });
        });
      }
    });

    let errors = [];

    //Get all appointments from tbl_Lieferplanung
    let url = `/api/Values/UploadAppointmentReturnData`;
    // let appointments = this.generateAjaxCall(url, data);
    let bugTest = await this.generateAjaxCall(url, data);

    errors.push(bugTest);

    if (monteri[0]) {
      url = `/api/Monter`;
      // monteureResponse = this.generateAjaxCall(url, monteri[0]);
     let monteriErr = await this.generateAjaxCall(url, monteri[0]);
     errors.push(monteriErr);
    }

    data.forEach(async row => {
      if (!row.SignedFiles) return;
      else {
       let filesErr = await this.generateAjaxCall(`/api/File`, {
          Pdf: row.SignedFiles,
          IDBerater: settings.CurrentIDBerater,
          AuftragNr: row.AuftragNr,
          PdfName: row.PdfName
        });

        errors.push(filesErr);
      }
    });
    // console.log("Appointmenti : ", appointments);
    // console.log("Monteri: ", monteureResponse);
 url = `/api/Picture`;
   let pictureErr = {Error: false, Success: true, ErrorText: "", AppointmentsList: []};
   if(fotosForUpload.length > 0){
    pictureErr = await this.generateAjaxCall(url, fotosForUpload)
   }
   errors.push(pictureErr);
  //delete fotos after upload 
  await this.db
  .table("pictures")
  .bulkDelete(fotosForUpload.map(row => row.id));
    //Dodati provjeru za errore / response svih generateAjaxCall funkcija

    let checkErr = errors.filter(e => e.Error === true);
    if(checkErr.length > 0) return { Error : true}  

    return { Error: false };
  }

  generateAjaxCall = async (url, data) => {
    return fetch(ServerUri + url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json; charset=utf-8"
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    }).then(response => {
      return response.json();
    })
      .then(res => {
        return res;//JSON.parse(res)
      }
      )
      .catch(function (err) {
        return err;
      });
  }

  async uploadBockData(settings){
    let dbBocks = await this.getAllBocks();
    let bocksForUpload = dbBocks.filter(b => b.ToUpload === 1);
    //Provjera kad nema bokova za upload
    let objToSend = {
      bockList: bocksForUpload,
      device: settings.CurrentUserName
    }

    let bocksToDelete = await this.generateAjaxCall('/api/Bock', objToSend);

    console.log(bocksToDelete);
  } 

  getAllData = async () => {
    let dbAppointmentsP = this.getAllAppointments();
    let dbAttachmentsP = this.getAllAttachments();
    let dbEnteredDataP = this.getAllEnteredData();
    let dbFotosP = this.getAllFotos();
    let dbPersonsP = this.getAllPersons();
    let dbBocksP = this.getAllBocks();
    let dbPositionsP = this.getAllPositions();
    let dbGeoLocationsP = this.getAllGeoLocations();
    let dbDriverList = this.getAllDrivers();

    let dh = new DateHelper();
    let days = [];
    for (let i = 0; i <= PAST_DAYS + FUTURE_DAYS; i++) {
      var dt = dh.getDateByIndex(i);
      days.push({ index: i, date: dt });
    }

    let res = [
      await dbAppointmentsP,
      await dbAttachmentsP,
      await dbEnteredDataP,
      await dbFotosP,
      await dbPersonsP,
      await dbBocksP,
      await dbPositionsP,
      await dbGeoLocationsP,
      await dbDriverList,
    ];

    return {
      appointments: res[0],
      attachments: res[1],
      enteredData: res[2],
      fotos: res[3],
      persons: res[4],
      bocks: res[5],
      positions: res[6],
      geoLocations: res[7],
      driverList: res[8],
      days: days
    };
  }

  async getAllAppointments() {
    return await this.db
      .table("auftrags")
      //.orderBy("StartDate")
      .toArray();
  }

  async getSpecificAppointment(UniqueID) {
    return await this.db.table("auftrags").where("UniqueID").equals(UniqueID).first();
  }

  async getAllAttachments() {
    let atts = await this.db.table("files").toArray();
    return atts;
  }

  async getAllEnteredData() {
    let data = await this.db.table("entereddata").toArray();
    return data;
  }

  async getAllFotos() {
    return await this.db.table("pictures").toArray();
  }

  async getAllPersons() {
    return await this.db.table('persons').toArray();
  }

  async getAllBocks() {
    return await this.db.table('bocks').toArray();
  }

  async getAllDrivers() {
    return await this.db.table('drivers').toArray();
  }

  getSpeficiedBock = async(BockNr) => {
    let allBocks = this.getAllBocks();
    let res = await allBocks;
    res = res.filter(b => b.Bock_Nr === BockNr);
    return res[0] || []
  }

  async getAllPositions() {
    return await this.db.table('positions').toArray();
  }

  async getAllGeoLocations() {
    return await this.db.table('geoLocations').toArray();
  }


  getAllDataFromService = async settings => {
    // let url = settings.URL;
    // if (!url.endsWith("/")) url = url + "/";

    //Lista fajlova koji postoje lokalno, da se ne preuzimaju ponovo.
    // let objToSend = {imei: settings.Berater};
    // let listOfAttachments = await this.db.table("attachments").toArray();
    // objToSend["list"] = await listOfAttachments.map(({ServiceID, FileName, Extension}) => ({ServiceId: ServiceID, FileName:FileName + Extension}))
    let today = moment().format("YYYY-MM-DD");
    if (settings.CurrentUserId === "") alert("Wrong user !");
    let url = ServerUri + `/api/Values?id=${settings.CurrentUserId}&datum=${today}&device=${settings.CurrentUserName}`;
    //let url = "http://versand.broemse.de:8080/api/Values?id=12&datum=2019-3-19&device=ReWe";


    // const data = await fetch(url);
    //         return JSON.parse(await data.json());

    return fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json; charset=utf-8"
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => {
        return response.json()
      })
      .then(res => res)
      .catch(function (err) {
        return err;
      });

  };

  getAllFilesFromService = async settings => {
    if (settings.CurrentUserId === "") alert("Wrong user !");
    let today = moment().format("YYYY-MM-DD");
    let url = ServerUri + `/api/File?id=${settings.CurrentUserId}&datum=${today}&device=${settings.CurrentUserName}`;

    return fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json; charset=utf-8"
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => {
        return response.json()
      })
      .then(res => JSON.parse(res))
      .catch(function (err) {
        return err;
      });
  }

  updateFahrerGeolocation = async settings => {

    let fahrerPos = await fetchCoordinates();
    let now = moment(new Date()).format("MM.DD.YYYY hh:mm");

    let url = ServerUri + `/api/GeoLocation/?lat=${fahrerPos.latitude}&lng=${fahrerPos.longitude}&time=${now}&id=${settings.CurrentUserId}&device=${settings.CurrentUserName}`;

    if(navigator.onLine){
      return fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json; charset=utf-8"
          // "Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "follow", // manual, *follow, error
        referrer: "no-referrer", // no-referrer, *client
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
      })
        .then(response => {
          return response.json()
        })
        .then(res => res)
        .catch(function (err) {
          return console.log("Greška kod update-a lokacije vozača. ", err);
        });
    }else{
      //nema internet konekcije, nije moguće upisati trenutnu lokaciju vozača
      return;
    }

    
  }

  getListOfDrivers = async id => {
    let url = ServerUri + `/api/Berater/DriverList`;
    return  fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "reload", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json; charset=utf-8"
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.UpdateDriverList(data)
        return data;
      })      
      .catch(function (err) {
        return err;
      });

    
     // return data;
      //console.log("Driver list data :", data);
  }

  UpdateDriverList = async(drivers) => {

    await this.db.drivers.clear()
    .then(() => this.db.table("drivers").bulkAdd(drivers))
    .catch(e => console.error("Delete failed !"));


  }

  updateDBAppointments = async (dbAppointments, appointments) => {
    //appointments that exist in remote, but not localy
    var toAdd = appointments.filter(app => {
      return !dbAppointments.some(value => {
        return (app.UniqueID != null && value.UniqueID === app.UniqueID) || (app.UniqueID == null && value.UniqueID == null && app.IDService === value.IDService); //unique
      });
    });

    //appointments that exist in localy, but not remotely
    var toRemove = dbAppointments.filter(app => {
      return !appointments.some(value => {
        return (value.UniqueID != null && value.UniqueID === app.UniqueID) || (value.UniqueID == null && app.UniqueID == null && app.IDService === value.IDService); //UniqueID
      });
    });
    toRemove.forEach(app => {
      app._deleted = true;
    });

    //appointments that exist both localy and on remote
    var toUpdate = appointments.filter(app => {
      return dbAppointments.some(value => {
        return (value.UniqueID != null && value.UniqueID === app.UniqueID) || (value.UniqueID == null && app.UniqueID == null && app.IDService === value.IDService); //UniqueID
      });
    });
    //console.log("toAdd:", toAdd);
    await this.db.table("auftrags").bulkAdd(toAdd);
    //if (toAdd.length > 0) console.log(`Added ${toAdd.length} auftrags!`);

    await this.db.table("auftrags").bulkPut(toUpdate);
    //if (toUpdate.length > 0) console.log(`Updated ${toUpdate.length} auftrags!`);

    await this.db
      .table("auftrags")
      .bulkDelete(toRemove.map(row => row.id));
    // if (toRemove.length > 0) console.log(`Removed ${toRemove.length} auftrags!`);
  };

  updateDBBocks = async (dbBocks, bocks) => {
    var toAdd = bocks.filter(app => {
      return !dbBocks.some(value => {
        return value.id === app.id;  //app.UniqueID !== null || value.FirmaID !== null; //unique
      });
    });

    var toRemove = dbBocks.filter(app => {
      return !bocks.some(value => {
        return value.id === app.id;
      });
    });

    toRemove.forEach(app => {
      app._deleted = true;
    });

    var toUpdate = bocks.filter(app => {
      return dbBocks.some(value => {
        return value.id === app.id;
      });
    });
    await this.db.table("bocks").bulkAdd(toAdd);
    //console.log(`Added ${toAdd.length} bocks`);
    await this.db.table("bocks").bulkPut(toUpdate);
    //console.log(`Updated ${toUpdate.length} bocks`);
    await this.db.table("bocks").bulkDelete(toRemove.map(row => row.id));
    //console.log(`Removed ${toRemove.length} bocks`);
  }

  updateDBPersons = async (dbPersons, persons) => {
    var toAdd = persons.filter(app => {
      return !dbPersons.some(value => {
        return value.id === app.id; //app.UniqueID !== null || value.Kd_ID != null
      });
    });
    var toRemove = dbPersons.filter(app => {
      return !persons.some(value => {
        return value.id === app.id;
      });
    });

    toRemove.forEach(app => {
      app._deleted = true;
    });

    var toUpdate = persons.filter(app => {
      return dbPersons.some(value => {
        return value.id === app.id;
      });
    });
    await this.db.table("persons").bulkAdd(toAdd);
    //console.log(`Added ${toAdd.length} persons`);
    await this.db.table("persons").bulkPut(toUpdate);
    //console.log(`Updated ${toUpdate.length} persons`);
    await this.db.table("persons").bulkDelete(toRemove.map(row => row.id));
    //console.log(`Removed ${toRemove.length} persons`);
  }

  updateDBPositions = async (dbPositions, positions) => {
    var toAdd = positions.filter(app => {
      return !dbPositions.some(value => {
        return value.AuftragId === app.AuftragId;
      });
    });
    var toRemove = dbPositions.filter(app => {
      return !positions.some(value => {
        return value.AuftragId === app.AuftragId;
      });
    });

    toRemove.forEach(app => {
      app._deleted = true;
    });

    var toUpdate = positions.filter(app => {
      return dbPositions.some(value => {
        return value.AuftragId === app.AuftragId;
      });
    });
    await this.db.table("positions").bulkAdd(toAdd);
    //console.log(`Added ${toAdd.length} positions`)
    await this.db.table("positions").bulkPut(toUpdate);
    //console.log(`Updated ${toUpdate.length} positions`);
    await this.db.table("positions").bulkDelete(toRemove.map(row => row.id));
    //  console.log(`Removed ${toRemove.length} positions`);
  }

  updateDBAttachments = async (dbAttachments, attachments) => {
    //appointments that exist in remote, but not localy
    var toAdd = attachments.filter(app => {
      return !dbAttachments.some(value => {
        return value.AuftragNr === app.AuftragNr;
      });
    });

    //appointments that exist in localy, but not remotely
    var toRemove = dbAttachments.filter(app => {
      return !attachments.some(value => {
        return value.AuftragNr === app.AuftragNr;
      });
    });
    toRemove.forEach(app => {
      app._deleted = true;
    });

    var toUpdate = dbAttachments.filter(app => {
      return attachments.some(value => {
        return value.AuftragNr === app.AuftragNr;
      });
    });

    await this.db
      .table("files")
      .bulkDelete(toRemove.map(row => row.id));
    await this.db.table("files").bulkPut(toUpdate);
    //console.log(`Updated ${toUpdate.length} attachments`);
    await this.db.table("files").bulkAdd(toAdd);
    // console.log(`Removed ${toRemove.length} attachments`);
    //  console.log(`Added ${toAdd.length} attachments`);

  }

  addDBPersons = async (persons) => {
    let row = Object.assign({}, persons);
    // console.log(row);

    // let personsDb = (await this.db.persons.toArray());

    // let t = Object.assign({}, personsDb[0], persons);
    // console.log(personsDb);
    let id = await this.db.table("persons").put(persons);
    row.id = id;
    return row;
  }
  

  deleteDBPersons = async (idToDelete) => {
    await this.db.table("persons").where("id").equals(idToDelete).delete();
    return idToDelete;
  }

  SaveAddedBock = async (bock) => {
    let currentId = -1;
    let allBocks = await this.db.table("bocks").orderBy("id").toArray();
    if(allBocks.length > 0) currentId = allBocks[0].id || -1;
    bock.id= --currentId;
    //Bokovi sa negativnim ID brojem predstavljaju bokove koji su dodani kroz skeniranje ili manuelni unos barcoda a ne postoje u tabeli sa bokovima.
    let row = Object.assign({}, bock);
    let id = await this.db.table("bocks").put(bock);
    row.id = id;
    return row;
  }

  deleteDBBocks = async (idToDelete) => {
    await this.db.table("bocks").where("id").equals(idToDelete).delete();
    return idToDelete;
  }

  async SavePropertyValue(app, prop, value) {
    return await this.UpdateEnteredRowData(app, prop, value);
  }

  async UpdateEnteredRowData(app, prop, value) {
    let row = await this.GetEnteredDataRow(app);

    row[prop] = value;
    let id = await this.db.table("entereddata").put(row);
    row.id = id;
    return row;
  }

  async GetEnteredDataRow(app) {
    let entereddata = await this.db.entereddata
      .where({ UniqueID: app.UniqueID })
      .toArray();

    // entereddata=entereddata.filter(c=>c.UniqueID===app.UniqueID);
    let row = {
      //IDService: app.IDService,
      UniqueID: app.UniqueID,
      EkOrt: "",
      EkStrasse: "",
      PlzOrt: "",
      GeliefertDescription: "",
      Persons: [],
      ErledigteArbeiten: '',
      Duration: 0,
      StartTime: null,
      SignatureBerater: null,
      SignatureKunde: null,
      AdditionalServiceNeeded: false,
      Finished: 0,
      Started: 0,
      Positions: [],
      Pdf: null,
      PdfName: "",
      KundenBesonderheiten: "",
      Signed: false,
      //On auftrag fertig tab
      Punkt1: false, 
      Punkt2: false,
      Punkt3: false,
      DruckbuchstabenKunde:"",
      DruckbuchstabenFahrer:"",
      FirmaPLZ: "",
      FirmaOrt: ""

    }
    if (entereddata.length > 0) {
      row = entereddata[0];
    } else {
      let appointment = (await this.db.auftrags
        .where({ UniqueID: app.UniqueID })
        .toArray());
      row = appointment.filter(c => c.UniqueID === app.UniqueID)[0];
    }
    return row;
  }

  async SaveData(app, values) {
    let row = await this.GetEnteredDataRow(app);
    row = Object.assign(row, values);
    let id = await this.db.table("entereddata").put(row);
    row.id = id;
    return row;
  }

  async SaveDataBock(values) {    
    let row = Object.assign({}, values);
    let id = await this.db.table("bocks").put(row);
    row.id = id;
    return row;
  }

  _arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  _base64ToArrayBuffer(base64) {
    let _b64 = base64;
    if (_b64.startsWith("data:image/png;base64,"))
      _b64 = _b64.substring(22);
    let raw = window.atob(_b64);
    let rawLength = raw.length;
    let array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  async SaveSignatures(app, value) {
    //alert("usao u save signature")
    let row = await this.GetEnteredDataRow(app);
    let today = moment().format("DD.MM.YYYY");
    row.SignatureBerater = value.SignatureBerater;
    row.SignatureKunde = value.SignatureKunde;
    //console.log("row",row.DruckbuchstabenFahrer, row.DruckbuchstabenKunde);
    let druckbuchstabenKunde = row.DruckbuchstabenKunde;
    let druckbuchstabenFahrer = row.DruckbuchstabenFahrer;
    let pdf = await this.db.files
      .where({
        id: app.UniqueID
      })
      .toArray();

    const pdfDoc = PDFDocumentFactory.load(
      this._base64ToArrayBuffer(pdf[0].Attachment)
    );
    const pages = pdfDoc.getPages();
    const COURIER_FONT = "Helvetica";
    const [courierFontRef] = pdfDoc.embedStandardFont("Helvetica");
    const beraterPngBytes = this._base64ToArrayBuffer(row.SignatureBerater);
    const kundePngBytes = this._base64ToArrayBuffer(row.SignatureKunde);

    const [kundePngRef] = pdfDoc.embedPNG(kundePngBytes);
    const [beraterPngRef] = pdfDoc.embedPNG(beraterPngBytes);
    const existingPage = pages[pages.length - 1]
      .addFontDictionary(COURIER_FONT, courierFontRef)
      .addImageObject("Kunde", kundePngRef)
      .addImageObject("Berater", beraterPngRef);


    const newContentStream = pdfDoc.createContentStream(
      drawImage("Kunde", {
        x: value.x - 70, //550 - value.x,
        y: 820 - value.y,
        width: 150,
        height: 80
      }),
      drawImage("Berater", {
        x: value.x + 120, //550 - value.x,
        y: 820 - value.y,
        width: 150,
        height: 80
      }),
      drawLinesOfText([today || " "], {
        x: value.x - 195,
        y: 840 - value.y,
        font: COURIER_FONT,
        size: 12,
        colorRgb: [0, 0, 0]
      }),
      drawLinesOfText([druckbuchstabenKunde || " "], {
        x: value.x - 35,
        y: 775 - value.y,
        font: COURIER_FONT,
        size: 12,
        colorRgb: [0, 0, 0]
      }),
      drawLinesOfText([druckbuchstabenFahrer || " "], {
        x: value.x + 145,
        y: 775 - value.y,
        font: COURIER_FONT,
        size: 12,
        colorRgb: [0, 0, 0]
      }),
    );
    existingPage.addContentStreams(pdfDoc.register(newContentStream));

    const pdfBytes = PDFDocumentWriter.saveToBytes(pdfDoc);
    const b64 = this._arrayBufferToBase64(pdfBytes);
    row.Pdf = b64;
    row.PdfName = value.PdfName;
    row.Signed = true;
    console.log("pdffile",b64);
    await this.db.table("entereddata").put(row);
    row.Pdf = null; // Base64 za PDF se nigdje ne koristi kroz aplikaciju za interfejs ili učitavanje. Uklonjen radi lakše obrade kroz state.
    return row;
  }//end of SaveSignatures
  


  async FotoAdd(app, data) {
    let id = await this.db.table("pictures").put({
      UniqueID: app.UniqueID,
      AuftragNr: app.AuftragNr,
      data: data
    });
    return { id, AuftragNr: app.AuftragNr, UniqueID: app.UniqueID, data };
  }

  async FotoRemove(id) {
    await this.db.table("pictures").delete(id);
  }

}


